import { authAPI } from '../config/auth-api';

/**
 * Filters categories based on admin's categoryAccess.
 * - If 'all' or not set → returns categories as-is
 * - If array → only returns matching categories & their allowed subcategories
 *   - Empty subcategories array [] = all subcategories of that category are allowed
 */
export const filterCategoriesByAccess = (categories) => {
  const adminData = authAPI.getAdminData();
  const categoryAccess = adminData?.categoryAccess;

  // 'all' or undefined = full access
  if (!categoryAccess || categoryAccess === 'all') {
    return categories;
  }

  // Build a map for quick lookup: { categoryId: subcategoryIds[] }
  const accessMap = {};
  categoryAccess.forEach(item => {
    accessMap[item.category] = item.subcategories || [];
  });

  return categories
    .filter(cat => accessMap.hasOwnProperty(cat.id))
    .map(cat => {
      const allowedSubs = accessMap[cat.id];
      // Empty array = all subcategories allowed
      if (!allowedSubs || allowedSubs.length === 0) {
        return cat;
      }
      // Filter to only allowed subcategories
      return {
        ...cat,
        subcategories: cat.subcategories.filter(sub =>
          allowedSubs.includes(sub.id)
        )
      };
    });
};
